import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Seattle = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesfroce  Consultant and Partner in seattle</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Drive growth with Codezix – expert Salesforce consulting and implementation in Seattle. Innovative CRM solutions tailored to your needs."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting seattle Salesforce implementation seattle Codezix Salesforce services CRM solutions seattle Salesforce experts seattle Salesforce partner seattle Custom Salesforce solutions"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In Seattle</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/seattle.webp')} alt="Salesforce consulting seattle" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className="explore-heading text-left">
                                <h2>Top-Rated Salesforce Consultant in Seattle and Trusted Business Partner</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">
                                In the heart of Seattle’s dynamic tech and business environment, companies are constantly seeking innovative ways to streamline operations, enhance customer relationships, and drive sustainable growth. At Codezix, we take pride in being recognized as a top Salesforce consultant in Seattle, offering end-to-end Salesforce solutions that empower businesses to achieve these goals with confidence.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                As a trusted Salesforce partner, Codezix provides tailored consulting services to help businesses unlock the full potential of the Salesforce platform. Our certified experts specialize in designing, implementing, and optimizing Salesforce solutions that are aligned with your company’s specific objectives. Whether you're a startup looking to build a solid CRM foundation or an enterprise in need of advanced customization and integration, our team is equipped to deliver outstanding results.
                            </p>
                            <p className="prose-lg wow fadeUp">
                                What sets us apart as a leading Salesforce consultant in Seattle is our deep understanding of local business needs combined with global Salesforce expertise. We work closely with organizations across a range of industries—including tech, healthcare, retail, and finance—to create scalable, flexible, and efficient Salesforce environments.
                            </p>
                            <p className="prose-lg">
                                At Codezix, our services go beyond simple implementation. We provide ongoing support, training, and strategic guidance to ensure your Salesforce solution evolves with your business. Our goal is to not only solve immediate CRM challenges but to become a long-term partner in your digital transformation journey.
                            </p>
                            <p className="prose-lg">
                                With a commitment to innovation, collaboration, and customer success, Codezix stands out as the go-to Salesforce consultant in Seattle. Let us help you harness the full power of Salesforce to improve workflows, enhance customer experiences, and achieve measurable growth. Connect with us today to begin your journey with a partner who truly understands your business.
                            </p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Comprehensive Salesforce Consulting in Seattle: Expert Solutions for Your Business</h2>
                                <p className="prose-lg">
                                    In the ever-evolving business landscape of Seattle, leveraging advanced CRM solutions is key to staying competitive. At Codezix, we offer comprehensive Salesforce consulting in Seattle to help businesses streamline their operations, improve customer engagement, and drive sustainable growth. Whether you're a small startup or a large enterprise, our Salesforce consulting services are designed to deliver customized, scalable solutions tailored to your specific needs.
                                </p>
                                <p className="prose-lg">
                                    Our certified consultants bring deep industry knowledge and technical expertise to every project. With Salesforce consulting in Seattle, we assist businesses across various sectors—technology, healthcare, finance, retail, and more—in unlocking the full potential of the Salesforce platform. From strategy and planning to implementation and optimization, Codezix ensures every stage of your Salesforce journey is smooth and effective.
                                </p>
                                <p className="prose-lg">
                                    What makes our Salesforce consulting in Seattle unique is our commitment to understanding your business challenges and goals. We don’t believe in one-size-fits-all solutions. Instead, we analyze your existing processes, identify gaps, and design a Salesforce solution that aligns perfectly with your objectives. Whether it's Sales Cloud, Service Cloud, Marketing Cloud, or custom app development, we deliver results that make an impact.
                                </p>
                                <p className="prose-lg">
                                    In addition to implementation, we offer integration services, training, and ongoing support, ensuring your team gets the most out of the platform. Our proactive approach helps reduce downtime, increase productivity, and improve decision-making through real-time data insights.
                                </p>
                                <p className="prose-lg">
                                    At Codezix, we’re more than just a Salesforce service provider—we’re your strategic partner. If you're looking for reliable, results-driven Salesforce consulting in Seattle, look no further. Let us help you transform your business processes and elevate customer experiences with the power of Salesforce. Connect with Codezix today to get started on your Salesforce journey.
                                </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants offer a thorough evaluation of your business needs, providing personalized strategies that enhance workflows and drive operational efficiency. We address common CRM challenges like low sales productivity and departmental misalignment, ensuring seamless communication and optimizing overall performance across your organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Transform your business with our expert implementation services. Our certified professionals specialize in setting up, customizing, and configuring cloud-based solutions and add-ons, fostering innovation, boosting productivity, and supporting long-term growth—all tailored to meet your specific business needs.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our consultants excel at crafting tailored Salesforce solutions that align with your unique business processes. We focus on solving CRM challenges, improving sales effectiveness, and enhancing interdepartmental collaboration, ensuring smooth and efficient operations that fuel business success.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Bring your app ideas to life with our advanced development services. Our certified developers, based in Seattle, create custom applications that seamlessly integrate with major platforms. We ensure your apps are functional, scalable, and aligned with your business goals, delivering impactful solutions that drive innovation and success.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Break down silos and optimize productivity with our expert integration services. We connect your key business systems, including ERP, CMS, DMS, and accounting software, enabling smooth data flow and improving collaboration across departments. Our integration solutions boost operational efficiency and streamline processes for greater effectiveness.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Migrate seamlessly from legacy systems with our reliable migration services. Our experienced team ensures a secure transition, preserving the integrity and accuracy of your customer data while minimizing disruptions, allowing you to smoothly shift from outdated systems to the powerful Salesforce platform. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We provide proactive monitoring and ongoing support to address potential issues before they affect your business operations. With continuous oversight, we reduce downtime, maintain optimal workflows, and help prevent disruptions, ensuring that your organization remains efficient and fully operational at all times.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Meet Our Salesforce Consulting Partner in Seattle: A Certified Team Driving Business Success</h2>
                                <p className="prose-lg">Our certified team stands out as a reliable Salesforce consulting partner in Seattle, delivering innovative CRM solutions tailored to your business goals. With deep technical knowledge and hands-on experience across industries, our consultants work closely with clients to design and implement Salesforce platforms that drive real impact. From streamlining workflows to enhancing customer engagement, we provide strategic guidance every step of the way. As a Salesforce consulting partner in Seattle, Codezix is committed to helping local businesses leverage Salesforce technology for sustainable growth and operational excellence. Partner with us to unlock your full potential.</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation seattle' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='Salesforce experts seattle' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce implementation seattle' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Salesforce implementation seattle' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>

                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Consultants in Seattle with Proven Expertise Across All Salesforce Clouds</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    At Codezix, our skilled Salesforce consultants in Seattle bring extensive experience across all major Salesforce Clouds, including Sales Cloud, Service Cloud, Marketing Cloud, and Experience Cloud. We understand that every business has unique needs, and our team is dedicated to delivering customized, cloud-specific solutions that drive measurable results. Whether you're looking to automate sales, improve customer support, or launch targeted marketing campaigns, our consultants provide the strategic insight and technical know-how to make it happen. As trusted Salesforce consultants in Seattle, we help businesses maximize their Salesforce investment and achieve long-term digital transformation.
                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-seattle#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-seattle#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-seattle#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve with Expert Salesforce Developers in Seattle</h2>
                                <p className="prose-lg">Our expert Salesforce developers in Seattle are committed to delivering customized Salesforce solutions for a wide range of industries. Whether you're in technology, healthcare, retail, finance, or manufacturing, our team understands the unique challenges each sector faces. We specialize in creating tailored Salesforce applications that streamline processes, improve customer engagement, and boost operational efficiency. With our Salesforce development expertise in Seattle, we help businesses unlock the full potential of their Salesforce platform, ensuring scalable solutions that align with industry-specific needs. Trust Codezix to drive innovation and success in your industry.</p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation seattle" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions seattle" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts seattle" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner seattle" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting seattle" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation seattle" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions seattle" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Certified Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">Over 80 skilled developers with 300+ certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, demonstrating client loyalty</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, ensuring lasting partnerships</li>
                                            <li className="wow fadeUp prose-lg">More than 10 years of industry expertise</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Comprehensive Support & Maintenance from start to finish</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support, available across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house development, ensuring top-notch quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery, guaranteeing smooth execution</li>
                                            <li className="wow fadeUp prose-lg">Thorough testing for reliable, high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Salesforce experts seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in California, <strong>3PL Central</strong> offers an advanced warehouse management system (WMS) designed to streamline operations, boost customer satisfaction, and fuel business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Salesforce partner seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in the UK, <strong>24 Fit Club</strong> is a dynamic fitness community dedicated to promoting health and well-being. Their expert team provides premium fitness coaching, online classes, and innovative insights to inspire clients and encourage body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a powerful CRM platform offering a comprehensive enterprise solution that’s accessible across various devices. Its dynamic app marketplace enhances marketing and sales collaboration, driving improved lead generation and building high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce implementation seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Located in Sugarland, Texas, Advologix is a digital consultancy focused on legal document and case management. They assist law firms, legal departments, and public service organizations in optimizing case processing through centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health helps physician practices integrate behavioral health services, including care management, brief therapy, and psychiatric consultations. With a team of expert clinicians, industry insights, and advanced technology, they improve patient care and outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Salesforce experts seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in Seattle, At Home Solutions offers personalized healthcare services aimed at improving quality of life for individuals of all ages. With over a decade of experience, they provide affordable, effective care, including companionship, customized support, and essential medical services.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In the digital age, e-commerce is essential for business success, driving fierce competition. As demand for online shopping grows, businesses must adopt scalable, innovative solutions to stay competitive and meet changing consumer expectations.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A major highlight of 2024 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce introduced Agentforce, a revolutionary tool powered by advanced AI, aimed at boosting employee productivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Salesforce experts seattle' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                Understanding Salesforce MuleSoft & How Codezix Assists with Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital world, businesses use various applications and platforms to streamline operations and enhance customer experiences. However, achieving smooth integration can be challenging—this is where Salesforce MuleSoft becomes essential...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Seattle;